import z from "zod";

import { item } from "../../authoring.js";
import {
  actionLevel,
  actionLevelOrNotApplicable,
  actionLevelOrUnknown,
  yesNo,
} from "./responseSets.js";

/**
 * The second version of the placeholder instrument, written out in full.
 *
 * Nothing here reads the version before it: a module says what its own version
 * asks, and a reviewer sees what changed by diffing two modules. What ties it
 * to its predecessor is the manifest, and the retired list below, which the pin
 * test derives independently and refuses if the two disagree.
 */

export const name = ["sample", "core", "1.1", "r1"] as const;

export const groups = {
  life_functioning: "life_functioning",
  trauma: "trauma",
} as const;

export const items = {
  school_attendance: "school_attendance",
  school_engagement: "school_engagement",
  family_history: "family_history",
  adjustment_to_trauma: "adjustment_to_trauma",
} as const;

/**
 * `school_behaviour` is dead for the life of the product: answers recorded
 * under it are judgements about the question it used to name, so no later
 * version of any variant in this family may ask it again.
 */
export const retiredItems = ["school_behaviour"] as const;

const lifeFunctioning = z
  .object({
    ...item(items.school_attendance, actionLevelOrNotApplicable)
      .withComment()
      .build(),
    // Optional where the retired item it stands beside was not: what is asked
    // and what must be answered are both free to move between versions,
    // because neither changes what a stored response means.
    ...item(items.school_engagement, actionLevel)
      .optional()
      .withComment()
      .build(),
    ...item(items.family_history, yesNo).withComment().build(),
  })
  .strict();

const trauma = z
  .object({
    ...item(items.adjustment_to_trauma, actionLevelOrUnknown)
      .withComment()
      .build(),
  })
  .strict();

export const schema = z
  .object({
    [groups.life_functioning]: lifeFunctioning,
    [groups.trauma]: trauma.optional(),
  })
  .strict();
